import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'leadingZero'
})
export class LeadingZeroPipe implements PipeTransform {

  transform(value: number, length: number): string {
    const numberString = value.toString();
    const leadingZeros = '0'.repeat(Math.max(0, length - numberString.length));
    return leadingZeros + numberString;
  }

}
